import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <FaqSection />
        <TopicsSection />
        <CarouselSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}